import React from 'react';

import classNames from 'classnames';

import { CoreEnums } from '@/utils/domain/constants';
import styles from './style.less';

const FT = CoreEnums.AttachmentFileTypeClassification;

/**
 * Visual file category from `AttachmentFileTypeClassification`.
 * Covers all backend types (full enum), grouped into families with distinct
 * color/label (document-manager style: color signals type at a glance).
 * Derived from the enum so value changes do not break mappings.
 */
const CATEGORY_BY_CLASSIFICATION = {
  [FT.Image]: 'image',
  [FT.Video]: 'video',
  [FT.Pdf]: 'pdf',
  [FT.Word]: 'word',
  [FT.Excel]: 'excel',
  [FT.PowerPoint]: 'ppt',
  [FT.MicrosoftProject]: 'project',
  [FT.Text]: 'text',
  [FT.Xml]: 'code',
  [FT.Html]: 'code',
  [FT.Json]: 'code',
  [FT.Zip]: 'archive',
  [FT.Audio]: 'audio',
  [FT.Rar]: 'archive',
  [FT.Font]: 'font',
  [FT.TextCsv]: 'excel',
  [FT.AndroidApk]: 'app',
  [FT.ExeFile]: 'app',
  [FT.ParquetFile]: 'data',
  [FT.OutlookMessage]: 'mail',
  [FT.Markdown]: 'code',
};

const FALLBACK_LABEL = {
  image: 'IMG',
  video: 'VID',
  pdf: 'PDF',
  word: 'DOC',
  excel: 'XLS',
  ppt: 'PPT',
  project: 'MPP',
  text: 'TXT',
  code: '{ }',
  archive: 'ZIP',
  audio: 'AUD',
  font: 'FONT',
  app: 'APP',
  data: 'DATA',
  mail: 'EML',
  unknown: 'FILE',
};

export const fileCategory = (classification) =>
  CATEGORY_BY_CLASSIFICATION[classification ?? 0] || 'unknown';

const labelFor = (fileName, category) => {
  const dot = (fileName || '').lastIndexOf('.');
  if (dot > -1) {
    const ext = fileName.slice(dot + 1).trim();
    if (ext && ext.length <= 4) return ext.toUpperCase();
  }
  return FALLBACK_LABEL[category] || FALLBACK_LABEL.unknown;
};

const FileTypeIcon = ({ fileTypeClassification, fileName, size = 'sm', className }) => {
  const category = fileCategory(fileTypeClassification);

  return (
    <span
      className={classNames(
        styles.fileIcon,
        styles[`fileIcon_${size}`],
        styles[`cat_${category}`],
        className,
      )}
      aria-hidden
    >
      <span className={styles.fileIconLabel}>{labelFor(fileName, category)}</span>
    </span>
  );
};

export default FileTypeIcon;
